import { AnbEnvironmentEnum } from '@anb/ng-core';

/**
 *  This file contains the configuration settings for production.
 */

export const Environment = {
  productionBuild: true,
  anbEnvironment: AnbEnvironmentEnum.prd,
  adfsClientId: 'anb.spa.nijb.prd',
  httpRequestMaxRetry: 2,
  adfsRedirectUri: 'https://eloket.natuurenbos.be/nijb/token',
  adfsAuthorizeUrl: 'https://adfs.natuurenbos.be/adfs/oauth2/authorize',
  loginUrl: 'https://eloket.natuurenbos.be/nijb/login',
  logoutUrl: 'https://adfs.natuurenbos.be/adfs/ls/?wa=wsignout1.0',
  API_BASE_PATH: 'https://nijb-api.natuurenbos.be',
  referentieDataUrl: 'https://referentiedata-api.natuurenbos.be',
  froalaEditorKey: 'KB3B1B1D3rD1H5D4I3B2B10A8E2B5D4etzhhkmeoh1lwC8db==',
  configuratieServiceUri: 'https://configuratie-api.natuurenbos.be',
  keys: ['/appl/configuratieservice/geo-url/geolocation', '/appl/configuratieservice/referentiedata-url', '/appl/configuratieservice/basisregister-url'],
};
